/** Custom signature-pack fields — level + quantity, plus first-time-signer
 * setups when the level is QES. Shared by the managed-org request form and
 * the reseller grant form so both speak the same shape. */
import { useTranslation } from "react-i18next";

import { OFFERED_PACK_LEVELS, type PackFields } from "./packFields";

export function SignaturePackFields({
  value,
  onChange,
  idPrefix = "pack",
}: {
  value: PackFields;
  onChange: (patch: Partial<PackFields>) => void;
  idPrefix?: string;
}) {
  const { t } = useTranslation();
  const isQes = value.level === "l3";
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      <div>
        <label className="label" htmlFor={`${idPrefix}-level`}>
          {t("packForm.level")}
        </label>
        <select
          id={`${idPrefix}-level`}
          className="input"
          value={value.level}
          disabled={OFFERED_PACK_LEVELS.length <= 1}
          onChange={(e) =>
            onChange({ level: e.target.value as PackFields["level"] })
          }
        >
          {/* Only the currently-offered levels (L1 for now). Re-enable L2/L3
              by extending OFFERED_PACK_LEVELS in packFields.ts. */}
          {OFFERED_PACK_LEVELS.map((lvl) => (
            <option key={lvl} value={lvl}>
              {t(`packForm.level${lvl.toUpperCase()}`)}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="label" htmlFor={`${idPrefix}-qty`}>
          {t("packForm.quantity")}
        </label>
        <input
          id={`${idPrefix}-qty`}
          type="number"
          min={1}
          max={100000}
          className="input"
          value={value.quantity}
          onChange={(e) => onChange({ quantity: Number(e.target.value) })}
        />
      </div>
      {isQes && (
        <div>
          <label className="label" htmlFor={`${idPrefix}-setups`}>
            {t("packForm.setups")}
          </label>
          <input
            id={`${idPrefix}-setups`}
            type="number"
            min={0}
            max={100000}
            className="input"
            value={value.setups}
            onChange={(e) => onChange({ setups: Number(e.target.value) })}
          />
          <p className="mt-0.5 text-[10px] text-nb-text-3">
            {t("packForm.setupsHint")}
          </p>
        </div>
      )}
    </div>
  );
}
